/* eslint-disable camelcase */
import styled from "@emotion/styled";
import PropTypes from "prop-types";

import { useOneElastic } from "@hmn/coolinarika-web-core/hooks";

import { withErrorBoundary } from "../../../../ErrorBoundary";
import {
    HeadingLabel,
    headingLabelSizes,
    headingLabelVariants,
    HeadingSection,
    headingSectionSizes,
} from "../../../../Heading/components";
import { HtmlContent } from "../../../../HtmlContent";
import { Image } from "../../../../Image";
import styles from "./Avatar.style";

const AvatarStyled = styled.div((props) => ({ ...styles(props) }));

const Avatar = ({ className, userId, label, title, inline, placeholderImageSrc, ...rest }) => {
    const { data: user } = useOneElastic({ resource: "ljudi", id: userId, enabled: !!userId });

    return (
        !!user && (
            <AvatarStyled className={className} inline={inline} {...rest}>
                <div className="avatar_asset">
                    <div className="avatarAsset_imageWrap">
                        <Image
                            image={user?.image?.id || placeholderImageSrc}
                            placeholder={placeholderImageSrc}
                            height={360}
                            width={360}
                            title={user?.display_name}
                            alt={user?.display_name}
                            className="avatarAsset_image"
                            ratio={1}
                        />
                    </div>
                </div>
                <div className="avatar_info">
                    {label && (
                        <HeadingLabel
                            isUppercase
                            className="AvatarInfo_label"
                            variant={headingLabelVariants.SECONDARY}
                            size={headingLabelSizes.SMALL}
                        >
                            <HtmlContent content={label} wrapperComponent="span" />
                        </HeadingLabel>
                    )}

                    {user?.display_name && (
                        <HeadingSection
                            className="avatarInfo_userName"
                            tagComponent="h1"
                            variant={headingSectionSizes.LARGE}
                        >
                            {user?.display_name}
                        </HeadingSection>
                    )}

                    {title && (
                        <div className="avatarInfo_title">
                            <HtmlContent content={title} wrapperComponent="span" />
                        </div>
                    )}
                </div>
            </AvatarStyled>
        )
    );
};

Avatar.propTypes = {
    className: PropTypes.string,
    userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    label: PropTypes.string,
    title: PropTypes.string,
    inline: PropTypes.bool,
    placeholderImageSrc: PropTypes.string,
};

Avatar.defaultProps = {
    className: undefined,
    userId: undefined,
    label: undefined,
    title: undefined,
    inline: false,
    placeholderImageSrc: "/images/placeholder/placeholder-user-profile.svg",
};

export default withErrorBoundary(Avatar);
